(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-scent-profiles]').forEach((data) => {
      if (data.dataset.scentBound) return;
      const form = data.closest('form');
      if (!form) return;
      const select = form.querySelector('[data-variant-select]');
      const profile = form.querySelector('[data-scent-profile]');
      const content = form.querySelector('[data-scent-profile-text]');
      if (!select || !profile || !content) return;
      let profiles;
      try { profiles = JSON.parse(data.textContent); } catch { return; }
      data.dataset.scentBound = 'true';
      function update() {
        const text = profiles[select.value] || '';
        content.textContent = text;
        profile.hidden = !text.trim();
      }
      form.addEventListener('change', update);
      form.addEventListener('click', (event) => {
        if (event.target.closest('[data-variant-choice]')) update();
      });
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
